import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    message: "",
    error: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // In a real application, this would be an API call
    // For now, we'll simulate a successful submission
    console.log("Form submitted:", formData);

    setFormStatus({
      submitted: true,
      message:
        "Thank you for your message! We will contact you within 24 hours.",
      error: false,
    });

    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      course: "",
      message: "",
    });

    // Reset status after 5 seconds
    setTimeout(() => {
      setFormStatus({
        submitted: false,
        message: "",
        error: false,
      });
    }, 5000);
  };

  const courses = [
    "Care Giver",
    "Child Minder",
    "Farming",
    "Warehouse Packer",
    "Psycho Social Counselling",
    "HIV Management",
    "Event Planning",
    "Corporate Event Management",
    "Beauty, Nails & Lashes",
    "Other/General Inquiry",
  ];

  const locations = [
    // {
    //   country: "South Africa",
    //   city: "Johannesburg",
    //   address: "Sunshare Tower, 1st Floor",
    //   type: "Physical Training Center",
    //   phone: "+27 780020549",
    // },
    // {
    //   country: "Zambia",
    //   city: "Lusaka",
    //   address: "Physical Training Center",
    //   type: "Physical Training Center",
    //   phone: "+260 773393067",
    // },
    // {
    //   country: "Kenya",
    //   city: "Nairobi",
    //   address: "Online Training",
    //   type: "Online Training",
    //   phone: "+27 780020549",
    // },
    // {
    //   country: "Mozambique",
    //   city: "Maputo",
    //   address: "Online Training",
    //   type: "Online Training",
    //   phone: "+27 780020549",
    // },
    {
      country: "Global",
      city: "Worldwide",
      address:
        "Global Training Online/Physical Training At Passion Care For You Offices",
      type: "Global Training",
      email: "info@passioncare4uglobal.com",
    },
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero section">
        <div className="container">
          <h1 className="section-title">Contact Passion Care 4 U</h1>
          <p className="section-subtitle">
            Get in touch with us to learn more about our training programs,
            enrollment process, or any other inquiries.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="contact-content">
          {/* Contact Form */}
          {/* <section className="contact-form-section">
            <h2>Send Us a Message</h2>
            <p>
              Fill out the form below and we'll get back to you as soon as
              possible.
            </p>

            {formStatus.submitted && (
              <div
                className={`form-message ${formStatus.error ? "error" : "success"}`}
              >
                {formStatus.message}
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your full name"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+27 123 456 789"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="course">Course Interest</label>
                <select
                  id="course"
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                >
                  <option value="">Select a course</option>
                  {courses.map((course, index) => (
                    <option key={index} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Tell us about your training needs or inquiry..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary submit-btn">
                Send Message
              </button>
            </form>
          </section> */}

          {/* Contact Information */}
          <section className="contact-info-section">
            <h2>Contact Information</h2>

            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h3>Email Us</h3>
                  <a href="mailto:info@passioncare4uglobal.com">
                    info@passioncare4uglobal.com
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h3>Call Us</h3>
                  {/* <a href="https://wa.me/+27786328699">+27 78 632 8699</a> */}
                  <a href="https://wa.me/+260773393067">+260 773393067</a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">🌐</div>
                <div>
                  <h3>Website</h3>
                  <a
                    href="https://passioncare4uglobal.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://passioncare4uglobal.com
                  </a>
                </div>
              </div>
            </div>

            <div className="locations-list">
              <h3>Our Locations</h3>

              {locations.map((location, index) => (
                <div className="location-card" key={index}>
                  <h4>
                    {location.country} - {location.city}
                  </h4>
                  <p>
                    <strong>Address:</strong> {location.address}
                  </p>
                  <p>
                    <strong>Type:</strong> {location.type}
                  </p>
                  <p>
                    <strong>Email:</strong> {location.email}
                  </p>
                </div>
              ))}
            </div>

            <div className="business-hours">
              <h3>Business Hours</h3>
              <div className="hours-grid">
                <div className="hours-item">
                  <span className="day">Monday - Thursday</span>
                  <span className="time">8:00 AM - 4:00 PM</span>
                </div>
                <div className="hours-item">
                  <span className="day">Friday - Saturday</span>
                  <span className="time">8:00 AM - 1:00 PM</span>
                </div>
                <div className="hours-item">
                  <span className="day">Sunday</span>
                  <span className="time">Closed</span>
                </div>
              </div>
            </div>

            <div className="quick-links">
              <h3>Quick Links</h3>
              <div className="links-grid">
                <a href="/services" className="quick-link">
                  View All Courses
                </a>
                <a href="/about" className="quick-link">
                  About Our Training
                </a>
                <a href="/services" className="quick-link">
                  Enrollment Process
                </a>
                {/* <a href="#faq" className="quick-link">
                  FAQ
                </a> */}
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Enrollment CTA */}
      <section className="enrollment-cta section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Enroll?</h2>
            <p>
              Secure your slot today and get 30% off on our comprehensive
              training programs. Limited spots available!
            </p>
            <div className="cta-buttons">
              <a href="https://wa.me/+27786328699" className="btn btn-primary">
                Call Now to Enroll
              </a>
              <a
                href="mailto:info@passioncare4uglobal.com"
                className="btn btn-secondary"
              >
                Email for Details
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
